const theme = {
  "primary": "#1e237e",
  "secondary": "#003ea9",
  "tertiary": "#565656",
  "accent": "#f7b600",
  "background": "#fff",
  "transparent": "rgba(0,0,0,0)",
  "shadow": "#b4b4c6",
  "actionPrimary": "#003ea9",
  "actionPrimaryHover": "#1869d6",
  "actionPrimaryFocus": "#1869d6",
  "actionPrimaryDisabled": "#b7c9e7",
  "actionPrimaryInactive": "#57587d",
  "actionPrimarySelected": "#003ea9",
  "actionSecondary": "#fff",
  "actionSecondaryHover": "#57587d",
  "actionSecondaryDisabled": "#fff",
  "actionSecondarySelected": "#57587d",
  "actionTertiary": "#fff",
  "actionTertiaryHover": "#fff",
  "actionTertiaryDisabled": "#fff",
  "actionTertiarySelected": "#fff",
  "actionToggle": "#212a58",
  "actionToggleOutline": "#616188",
  "actionToggleHover": "#57587d",
  "actionToggleDisabled": "#c2c0cb",
  "actionToggleSelected": "#6f7099",
  "actionToggleHighlightBackgroundFocus": "#e0eafa",
  "actionFixed": "#f2f4f8",
  "actionFavorite": "#00329e",
  "actionInputActive": "#b7c9e7",
  "actionInputDisabled": "#b4b4c6",
  "font": "OpenSans,sans-serif",
  "fontColor": "#222",
  "fontColorHeadline": "#2a2e69",
  "fontColorDark": "#363636",
  "fontColorInfo": "#57587d",
  "fontColorFinePrint": "#565656",
  "fontSize": "14px",
  "fontWeightLight": "300",
  "fontWeightRegular": "400",
  "fontWeightSemibold": "600",
  "fontWeightBold": "700",
  "fontDirection": "ltr",
  "lineHeight": "1.25rem",
  "linkColor": "#0051dc",
  "linkColorHover": "#0051dc",
  "linkColorFocus": "#0051dc",
  "linkColorActive": "#003ea9",
  "linkColorVisited": "#0051dc",
  "linkColorDisabled": "#b4b4c6",
  "linkUnderline": "none",
  "linkUnderlineHover": "underline",
  "linkUnderlineFocus": "underline",
  "linkInlineUnderline": "underline",
  "focusOutlineColor": "#15195a",
  "focusOutlineColorReadonly": "#57587d",
  "notificationSuccess": "#077844",
  "notificationSuccessLight": "#e1f0e7",
  "notificationInformation": "#2a2e69",
  "notificationInformationLight": "#e5e4ec",
  "notificationWarning": "#ff9800",
  "notificationWarningLight": "#fff2df",
  "notificationError": "#d50000",
  "notificationErrorLight": "#f9dedf",
  "notificationForegroundLight": "#fff",
  "notificationForegroundDark": "#222",
  "notificationAlertPadding": "1rem",
  "navigationBackground": "#15195a",
  "navigationForeground": "#fff",
  "navigationBorder": "#1e237e",
  "navigationItemHover": "#1e237e",
  "navigationDivider": "#57587d",
  "navDefaultBackground": "#1a1f71",
  "navConsumerBackground": "#0d2e8c",
  "navMarketingBackground": "linear-gradient(to right, #1a1f71, #0d2e8c)",
  "navSkipBackground": "#ecece8",
  "navLink": "#b4b4c6",
  "navLinkFocusOutline": "#fff",
  "navLinkHoverBackground": "#15195a",
  "navButtonActiveBackground": "#15195a",
  "navLinkActive": "#fff",
  "navLinkDefaultActiveBorder": "#7fa7ed",
  "navLinkMarketingActiveBorder": "#fa9b00",
  "navLinkMarketingActiveBorderGradient": "linear-gradient(to right, #fa9b00, #f4ca12)",
  "navLinkMarketingActiveBorderGradientMobile": "linear-gradient(to bottom, #fa9b00, #f4ca12)",
  "navDropdownBackground": "#15195a",
  "navListboxBorder": "#2a2e69",
  "navListboxHoverBackground": "#2a2e69",
  "progressBackground": "#e0eafa",
  "progressForeground": "#0842a6",
  "progressAccent": "#f7b600",
  "progressGaugeBackgroundNotStarted": "#003ea9",
  "progressGaugeBackgroundInProgress": "#0051dc",
  "progressGaugeBackgroundComplete": "#003ea9",
  "progressGaugeBackgroundApproved": "#077844",
  "progressGaugeRingNotStarted": "#e0eafa",
  "progressGaugeRingInProgress": "#003ea9",
  "progressGaugeRingComplete": "#003ea9",
  "progressGaugeRingApproved": "#077844",
  "progressGaugeTextNotStarted": "#6f7083",
  "progressGaugeTextInProgress": "#003ea9",
  "progressGaugeTextComplete": "#003ea9",
  "progressGaugeTextApproved": "#077844",
  "progressGaugeIconColor": "#fff",
  "accordionHeader": "#2a2e69",
  "accordionBackground": "#fff",
  "badgeAccentFill": "#f7b600",
  "badgeAccentLabel": "#222",
  "badgeCriticalFill": "#d50000",
  "badgeCriticalLabel": "#fff",
  "badgeWarningFill": "#ff9800",
  "badgeWarningLabel": "#222",
  "badgeStableFill": "#077844",
  "badgeStableLabel": "#fff",
  "badgeDisabledFill": "#d7d7de",
  "badgeDisabledLabel": "#222",
  "badgeStatusFill": "rgba(0,0,0,0)",
  "badgeStatusLabel": "#222",
  "breadcrumbPaddingHorizontal": ".5rem",
  "breadcrumbSeparatorColor": "#767676",
  "buttonRadius": "2px",
  "buttonDefaultText": "#fff",
  "buttonDefaultTextHover": "#fff",
  "buttonDefaultTextFocus": "#fff",
  "buttonDefaultTextActive": "#fff",
  "buttonDefaultTextDisabled": "#fff",
  "buttonDefaultTextBackground": "#003ea9",
  "buttonDefaultTextSelected": "#fff",
  "buttonDefaultTextBackgroundHover": "#1a1f71",
  "buttonDefaultTextBackgroundFocus": "#0051dc",
  "buttonDefaultTextBackgroundActive": "#0051dc",
  "buttonDefaultTextDisabledBackground": "#d7d7de",
  "buttonSecondaryText": "#003ea9",
  "buttonSecondaryTextHover": "#0051dc",
  "buttonSecondaryTextFocus": "#0051dc",
  "buttonSecondaryTextActive": "#fff",
  "buttonSecondaryTextDisabled": "#fff",
  "buttonSecondaryTextHoverBackground": "#e0eafa",
  "buttonSecondaryTextBackground": "#fff",
  "buttonSecondaryTextBackgroundHover": "#e0eafa",
  "buttonSecondaryTextBackgroundFocus": "#e0eafa",
  "buttonSecondaryTextBackgroundActive": "#0051dc",
  "buttonSecondaryTextBackgroundDisabled": "#d7d7de",
  "buttonSecondaryTextBorder": "#003ea9",
  "buttonSecondaryTextBorderHover": "#0051dc",
  "buttonSecondaryTextBorderFocus": "#0051dc",
  "buttonSecondaryTextBorderActive": "#0051dc",
  "buttonTertiaryText": "#0051dc",
  "buttonTertiaryTextHover": "#0051dc",
  "buttonTertiaryTextFocus": "#0051dc",
  "buttonTertiaryTextActive": "#fff",
  "buttonTertiaryTextDisabled": "#fff",
  "buttonTertiaryTextBackground": "rgba(255,255,255,0.7)",
  "buttonTertiaryTextBackgroundHover": "#e0eafa",
  "buttonTertiaryTextBackgroundFocus": "#e0eafa",
  "buttonTertiaryTextBackgroundActive": "#0051dc",
  "buttonTertiaryTextBackgroundDisabled": "#d7d7de",
  "buttonTertiaryTextBorder": "#003ea9",
  "buttonTertiaryTextBorderHover": "#0051dc",
  "buttonTertiaryTextBorderFocus": "#0051dc",
  "buttonIcon": "#003ea9",
  "buttonIconLight": "#0051dc",
  "buttonIconLightHover": "#0051dc",
  "buttonIconLightBackgroundHover": "#e0eafa",
  "buttonIconLightDiabled": "#d7d7de",
  "avatarInitialsBackground": "#003ea9",
  "avatarLogoBackground": "#15195a",
  "avatarLogoForeground": "#fff",
  "avatarTextBackground": "rgba(0,0,0,0)",
  "avatarTextDarkColor": "#15195a",
  "cardBackground": "#fff",
  "cardBorder": "#d7d7de",
  "cardBorderRadius": "4px",
  "cardPadding": "1.25rem",
  "cardContentCategoryBackground": "#1a1f71",
  "cardContentCategoryTitle": "#fff",
  "cardContentCategoryIcon": "#fff",
  "cardContentHeaderTitle": "#fff",
  "cardContentMiniBorderBottom": "#1a1f71",
  "cardContentDashSeparator": "#00329e",
  "cardDashboardSubtitle": "#767676",
  "cardDashboardMiniSuccess": "notification-success",
  "cardDashboardMiniError": "notification-error",
  "cardArtRippleColor": "#fff",
  "cardArtRippleBorderColor": "rgba(0,0,0,0)",
  "cardArtRippleZeroBackgroundColor": "rgba(255,255,255,0.1)",
  "cardArtRippleZeroBorderColor": "rgba(255,255,255,0.2)",
  "cardArtRippleThirtythreeBackgroundColor": "rgba(255,255,255,0.6)",
  "cardArtRippleThirtythreeBorderColor": "rgba(255,255,255,0.6)",
  "cardArtRippleThirtyfourBorderColor": "rgba(255,255,255,0.6)",
  "cardArtRippleOnehundredBorderColor": "rgba(255,255,255,0.9)",
  "cardArtRippleGoldColor": "#f7b600",
  "cardArtRippleZeroBackgroundGoldColor": "rgba(247,182,0,0.1)",
  "cardArtRippleZeroBorderGoldColor": "rgba(247,182,0,0.2)",
  "cardArtRippleThirtythreeBackgroundGoldColor": "rgba(247,182,0,0.6)",
  "cardArtRippleThirtythreeBorderGoldColor": "rgba(247,182,0,0.6)",
  "cardArtRippleThirtyfourBorderGoldColor": "rgba(247,182,0,0.6)",
  "cardArtRippleOnehundredBorderGoldColor": "rgba(247,182,0,0.9)",
  "cardArtShimmerColor": "rgba(255,255,255,0.2)",
  "cardArtMuteColor": "rgba(118,118,118,0.8)",
  "actionBarActiveControlsBackground": "#e0eafa",
  "dataTableHeaderText": "#2a2e69",
  "dataTableHeaderBackground": "#fff",
  "dataTableHeaderUnderline": "#2a2e69",
  "dataTableRowBackground": "#fff",
  "dataTableRowBackgroundAlt": "#f2f4f8",
  "dataTableRowBackgroundHover": "#e0eafa",
  "dataTableRowBackgroundPressed": "#d7d7de",
  "dataTableRowBackgroundFocus": "#e0eafa",
  "dataTableRowBackgroundSelected": "#d7d7de",
  "dataTableDividerLine": "#d7d7de",
  "dataTablePadding": "14px",
  "dataTableheaderHeight": "48px",
  "dataTablerowHeight": "72px",
  "dataTablerowHeightCompact": "44px",
  "datePickerInputBtnIconBackgroundActive": "#0051dc",
  "datePickerInputBtnIconReadonlyDisabled": "#b4b4c6",
  "datePickerCalendar": "#fff",
  "datePickerCalendarShadow": "0 0 4px 0 rgba(180,180,198,0.4)",
  "datePickerCalendarHeaderDivider": "#d7d7de",
  "datePickerCalendarDatesBtnText": "#2a2e69",
  "datePickerCalendarDatesBtnBackground": "rgba(0,0,0,0)",
  "datePickerCalendarDatesBtnBackgroundFocusVisibleHover": "#e0eafa",
  "datePickerCalendarDatesBtnTextActive": "#fff",
  "datePickerCalendarDatesBtnBackgroundActive": "#0051dc",
  "datePickerCalendarDatesBtnTextSelected": "#fff",
  "datePickerCalendarDatesBtnBackgroundSelected": "#003ea9",
  "datePickerCalendarDatesBtnPreviousAndNextMonth": "#616188",
  "datePickerCalendarDatesBtnPreviousAndNextMonthSelected": "#fff",
  "datePickerCalendarDateBtnLabelBorderCurrent": "#2a2e69",
  "datePickerCalendarDateBtnLabelBorderCurrentAndSelected": "#fff",
  "dialogCurtainColor": "rgba(0,0,0,0.3) !important",
  "dialogPadding": "1.5rem",
  "inputBackground": "#fff",
  "inputBackgroundDisabled": "#b4b4c6",
  "inputBackgroundReadonly": "#222",
  "inputIcon": "#616188",
  "inputFieldHeight": "1.5rem",
  "inputFontSize": "16px",
  "inputLabel": "#616188",
  "inputLabelHover": "#616188",
  "inputLabelFocus": "#0051dc",
  "inputLabelReadonly": "#616188",
  "inputLabelDisabled": "#b4b4c6",
  "inputLabelError": "#d50000",
  "inputPlaceholder": "#767676",
  "inputUnderline": "#616188",
  "inputUnderlineHover": "#003ea9",
  "inputUnderlineFocus": "#0051dc",
  "inputUnderlineReadonly": "#616188",
  "inputUnderlineDisabled": "#616188",
  "vdsInputWidth": "200px",
  "vdsMessageMargin": "30px",
  "footerBackground": "#f2f4f8",
  "footerTextColor": "#2a2e69",
  "footerCopyrightColor": "#616188",
  "radioBackground": "#fff",
  "radioBackgroundDisabled": "#b4b4c6",
  "radioBackgroundChecked": "#003ea9",
  "radioBoxShadowChecked": "#fff",
  "radioChecked": "#003ea9",
  "radioBorderFocus": "#0051dc",
  "radioOutlineBackgroundFocus": "#e0eafa",
  "listBulletColor": "#2a2e69",
  "listboxBackground": "#fff",
  "listboxBackgroundHover": "#003ea9",
  "listboxBackgroundActive": "#0051dc",
  "listboxBackgroundFocus": "#003ea9",
  "listboxBacgroundMultiSelected": "#e0eafa",
  "listboxTextHover": "#fff",
  "listboxTextActive": "#fff",
  "listboxTextFocus": "#fff",
  "listboxBorder": "#b4b4c6",
  "paginationItemText": "#222",
  "paginationItemTextActive": "#003ea9",
  "paginationItemBackground": "rgba(0,0,0,0)",
  "paginationItemBackgroundActive": "#e0eafa",
  "paginationDisabled": "#c2c0cb",
  "paginationBtnStepSize": "32px",
  "paginationLinkStepSize": "30px",
  "paginationPageSize": "100%",
  "panelBackground": "#fff",
  "panelBorder": "#d7d7de",
  "panelShadow": "0 0 4px #d7d7de",
  "ratingStarSize": "48px",
  "ratingStar": "#003ea9",
  "ratingStarHover": "#0051dc",
  "ratingStarActive": "#003ea9",
  "ratingStarDisabled": "#b4b4c6",
  "selectGroupBottomMargin": "32px",
  "sliderTrackBackground": "#d7d7de",
  "sliderTrackBorder": "#616188",
  "sliderRangeBackground": "#003ea9",
  "sliderDiscreteNumberDefaultTicks": "#616188",
  "sliderDiscreteNumberRangeTick": "#e0eafa",
  "sliderSliderLabelText": "#616188",
  "sliderSliderLabelTextActiveFocus": "#0051dc",
  "sliderSliderLabelValue": "#222",
  "sliderSliderLabelDisabled": "#b4b4c6",
  "sliderThumbBackgroundDefaultValueRest": "#fff",
  "sliderThumbBackgroundDefaultValueHover": "#fff",
  "sliderThumbBackgroundDefaultValueFocus": "#fff",
  "sliderThumbBackgroundDefaultValueActive": "#fff",
  "sliderThumbBackgroundDefaultValueDisabled": "#fff",
  "sliderThumbBorderDefaultValueRest": "#003ea9",
  "sliderThumbBorderDefaultValueHover": "#003ea9",
  "sliderThumbBorderDefaultValueFocus": "#15195a",
  "sliderThumbBorderDefaultValueActive": "#15195a",
  "sliderThumbBorderDefaultValueDisabled": "#b4b4c6",
  "sliderThumbBackgroundRest": "#003ea9",
  "sliderThumbBackgroundHover": "#0051dc",
  "sliderThumbBackgroundFocus": "#0051dc",
  "sliderThumbBackgroundActive": "#0051dc",
  "sliderThumbBackgroundDisabled": "#b4b4c6",
  "sliderThumbBorderRest": "rgba(0,0,0,0)",
  "sliderThumbBorderHover": "rgba(0,0,0,0)",
  "sliderThumbBorderFocus": "#15195a",
  "sliderThumbBorderActive": "#15195a",
  "sliderThumbBorderDisabled": "#b4b4c6",
  "sliderThumbHighlightBackgroundFocus": "#e0eafa",
  "sliderThumbHighlightBorderFocus": "#15195a",
  "stageBackground": "#e8f0fb",
  "stageBorder": "#fff",
  "statusNotStarted": "#6f7083",
  "statusCompleted": "#1869d6",
  "statusApproved": "#398c47",
  "statusInProgressIndicator": "#ccd8ee",
  "tooltipText": "#222",
  "tooltipBackground": "#fff",
  "tooltipOutline": "#d7d7de",
  "tooltipPadding": ".25rem",
  "wizardForeground": "#003ea9",
  "wizardBackground": "#fff",
  "wizardBorder": "rgba(0,0,0,0)",
  "wizardHoverForeground": "#003ea9",
  "wizardHoverBackground": "#e0eafa",
  "wizardHoverBorder": "rgba(0,0,0,0)",
  "wizardActiveForeground": "#003ea9",
  "wizardActiveBackground": "#fff",
  "wizardActiveBorder": "#15195a",
  "wizardCompletedForeground": "#fff",
  "wizardCompletedBackground": "#077844",
  "wizardCompletedBorder": "#077844",
  "wizardErrorForeground": "#d60036",
  "wizardErrorBackground": "#fff",
  "wizardErrorBorder": "#d60036",
  "dividerStandard": "#d7d7de",
  "dividerSection": "#2a2e69"
};

module.exports = theme;
